import styled from 'styled-components';

// Tab compacta — substitui o card grande com gradient + ícone gigante.
// Layout: ícone pequeno à esquerda, nome+contador empilhados à direita.
// Active: fill lightblue + texto branco. Inactive: ghost (transparente
// com border + texto muted). Padrao consistente com chips/segmented
// controls do resto do app.
export const Container = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  font-family: inherit;
  text-align: left;
  transition: all 150ms ease;
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme.colors.lightblue
        : props.theme.colors.disabled};
  background: ${(props) => {
    if (props.disabled) return 'transparent';
    if (props.active) return props.theme.colors.lightblue;
    return props.theme.title === 'light'
      ? 'rgba(0, 0, 0, 0.02)'
      : 'rgba(255, 255, 255, 0.03)';
  }};
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};

  :hover {
    ${(props) =>
      !props.disabled &&
      !props.active &&
      `
      border-color: ${props.theme.colors.lightblue};
      background: ${
        props.theme.title === 'light'
          ? 'rgba(0, 159, 216, 0.06)'
          : 'rgba(59, 191, 241, 0.08)'
      };
    `}
  }
`;

// Icone a esquerda — pequeno e discreto. Quando ativo, fica branco;
// quando inativo, herda cor do label.
export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    filter: ${(props) =>
      props.parentActive ? 'brightness(0) invert(1)' : 'none'};
    opacity: ${(props) => (props.parentActive ? 1 : 0.65)};
  }
`;

// Conteudo a direita — tipo (Sistema/Set Point) discreto, nome em
// destaque, contador como pill pequeno embaixo.
export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;

  /* Tipo: "Sistema" ou "Set Point" */
  > h3:first-child {
    margin: 0;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    line-height: 1;
    color: ${(props) =>
      props.active
        ? 'rgba(255, 255, 255, 0.75)'
        : props.theme.colors.label};
    opacity: ${(props) => (props.active ? 1 : 0.75)};
  }

  /* Nome: "Medicoes de Campo", "Alarme", etc */
  > span {
    font-size: 13px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    line-height: 1.1;
    color: ${(props) =>
      props.active
        ? props.theme.colors.white
        : props.theme.colors.darkerblue};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Contador "X Variáveis" - pill discreto */
  > h3:last-child {
    margin: 2px 0 0;
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    padding: 1px 6px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
    background: ${(props) =>
      props.active
        ? 'rgba(255, 255, 255, 0.22)'
        : props.theme.title === 'light'
        ? 'rgba(0, 0, 0, 0.06)'
        : 'rgba(255, 255, 255, 0.08)'};
    color: ${(props) =>
      props.active
        ? props.theme.colors.white
        : props.theme.colors.label};
  }
`;
